import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import { saveitem, saveuserdata } from "../../utils/firebasefunctions";
import { useNavigate } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { actionType } from "../context/reducer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from "react-toastify";
import { CiCirclePlus } from "react-icons/ci";
import { FaCircleMinus } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { RotatingLines } from "react-loader-spinner";
import * as XLSX from "xlsx";
import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import {
  getDownloadURL,
  ref,
  uploadBytes,
  uploadBytesResumable,
} from "firebase/storage";
import { storage, app } from "../../firebase.config";
import TimePicker from "react-time-picker";
import { FaDollarSign } from "react-icons/fa";
import { FaPercent } from "react-icons/fa";
import { GoogleMap, LoadScript, Marker, Circle } from "@react-google-maps/api";
import { geolib } from "geolib";
import {
  fromAddress,
  fromLatLng,
  geocode,
  setKey,
  setLanguage,
  setRegion,
} from "react-geocode";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { IoIosCloseCircle } from "react-icons/io";
import DesignationPopUp from "../components/DesignationPopUp";

// import Section2 from '../components/Homesection/section2'

function SortableItem({
  id,
  inneritem,
  innerindex,
  index,
  setcleanertasks,
  handledesignationChange,
  handletaskdesignationChange,
  designations,
  cleanertasks,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });
  const [designationpopup, setdesignationpopup] = useState(false);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className="row">
      <div
        key={innerindex.toString()}
        className="flex flex-row justify-start items-center mb-[10px]"
      >
        <div className="mt-5 ">
          <FaCircleMinus
            onClick={() => {
              let data = [...cleanertasks];
              data[index].numberoftasks = data[index].numberoftasks - 1;
              data[index].tasksdata.splice(innerindex, 1);
              setcleanertasks(data);
            }}
            className=" text-red-500 w-[15px] h-[15px] hover:cursor-pointer"
          />
        </div>
        <div className="mt-4 ml-[7px]">
          <span
            {...attributes}
            {...listeners}
            className="drag-handle  text-white text-[30px]"
          >
            ☰
          </span>
        </div>
        <div className=" w-full ml-[20px]">
          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
            Description
          </p>
          <textarea
            type="text"
            placeholder="Enter task..."
            rows={1}
            value={inneritem.tasks}
            onChange={(event) => {
              handledesignationChange(event, index, "Cleaner", innerindex);
            }}
            className={`input relative px-4 ${
              inneritem.tasks == "" ? " text-gray-500 " : "text-textcolor"
            } text-sm   PoppinsRegular w-full h-[75px] rounded-xl border border-bordercolor items-center flex bg-themelightblack`}
          />
        </div>
        <div className="w-[250px] shrink-0 ml-[10px]">
          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
            Designation
          </p>
          <div className="relative">
            <div
              onClick={() => {
                setdesignationpopup(true);
              }}
              className={`input px-4 ${
                inneritem.designation ? "text-textcolor" : "text-gray-500"
              } text-sm PoppinsRegular w-full h-[75px] rounded-xl border border-bordercolor flex flex-row items-center justify-between bg-themelightblack hover:cursor-pointer`}
            >
              <p className="truncate">
                {inneritem.designation
                  ? inneritem.designation
                  : "Select Designation"}
              </p>
              {inneritem.designation ? (
                <IoIosCloseCircle
                  onClick={(event) => {
                    event.stopPropagation();
                    handletaskdesignationChange("", index, innerindex);
                  }}
                  className="text-red-500 ml-[5px] w-[15px] h-[15px] shrink-0 hover:cursor-pointer"
                />
              ) : null}
            </div>
            <DesignationPopUp
              visible={designationpopup}
              data={designations}
              activateoutsidecontainerclick={() => {
                setdesignationpopup(false);
              }}
              onClick={(item) => {
                handletaskdesignationChange(
                  item.designation,
                  index,
                  innerindex,
                );
                setdesignationpopup(false);
              }}
              style={{ top: "80px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function CreateProject() {
  const [{ user, employees }, dispatch] = useStateValue();
  const [taskdescription, settaskdescription] = useState("");
  const [bio, setbio] = useState("");
  const [taskname, settaskname] = useState("");
  const [selectedemployee, setselectedemployee] = useState("");
  const [duedate, setduedate] = useState(new Date());
  const [startdate, setstartdate] = useState(new Date());
  const [employeepopup, setemployeepopup] = useState(false);
  const [loader, setloader] = useState(false);
  const [picturedata, setpicturedata] = useState("");
  const [picture, setpicture] = useState("");
  const [customeremail, setcustomeremail] = useState("");
  const [customerphonenumber, setcustomerphonenumber] = useState("");
  const [password, setpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const [expressdeliveryfixedmaxhours, setexpressdeliveryfixedmaxhours] =
    useState(0);
  const [expressdeliveryfixed, setexpressdeliveryfixed] = useState(0);
  const [expressdeliveryhourly, setexpressdeliveryhourly] = useState(0);
  const [Location, setLocation] = useState("");
  const [locationscan, setlocationscan] = useState(false);
  const [normalstarttime, setnormalstarttime] = useState("00:00");
  const [normalendtime, setnormalendtime] = useState("13:00");
  const [normalPer, setnormalPer] = useState("");
  const [eveningstarttime, seteveningstarttime] = useState("13:01");
  const [eveningendtime, seteveningendtime] = useState("19:00");
  const [eveningPer, seteveningPer] = useState("");
  const [nightstarttime, setnightstarttime] = useState("19:01");
  const [nightendtime, setnightendtime] = useState("23:59");
  const [nightPer, setnightPer] = useState("");
  const [selected, setSelected] = useState("option1");
  const [multiplicatorPer, setmultiplicatorPer] = useState(0);
  const [fixedprice, setfixedprice] = useState(0);
  const [geofenceRadius, setgeofenceRadius] = useState(1000);
  const [locationKey, setlocationKey] = useState(0);
  const LIBRARIES = ["places"];
  const [cleanertasks, setcleanertasks] = useState([
    {
      day: "Monday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Tuesday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Wednesday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Thursday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Friday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Saturday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Sunday",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Monthly",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Quarterly",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
    {
      day: "Yearly",
      numberoftasks: 1,
      tasksdata: [
        {
          id: 0,
          tasks: "",
          completed: false,
          designation: "",
        },
      ],
    },
  ]);

  const [geofenceCenter, setgeofenceCenter] = useState({
    lat: 60.1699,
    lng: 24.9384,
  });

  const darkTheme = [
    { elementType: "geometry", stylers: [{ color: "#212121" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
    {
      featureType: "administrative",
      elementType: "geometry",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#757575" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#181818" }],
    },
    {
      featureType: "road",
      elementType: "geometry.fill",
      stylers: [{ color: "#2c2c2c" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212121" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#000000" }],
    },
  ];

  const auth = getAuth();
  const fileInput = useRef();
  const apikey = "AIzaSyDHDrEb9r2EEgcMLoWKp6aGVA9WIq0kIho";
  const containerStyle = {
    width: "100%",
    height: "500px",
  };

  useEffect(() => {
    //    setKey('AIzaSyDHDrEb9r2EEgcMLoWKp6aGVA9WIq0kIho'); // Set API key
    //    setLanguage("en"); // Set language
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setgeofenceCenter({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (err) => {
          console.log(err.message);
        },
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  }, []);

  const handleTaskDragEnd = (dayIndex, event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    setcleanertasks((prev) => {
      const day = prev[dayIndex];

      const oldIndex = day.tasksdata.findIndex((t) => t.id === active.id);
      const newIndex = day.tasksdata.findIndex((t) => t.id === over.id);

      const updatedTasks = arrayMove(day.tasksdata, oldIndex, newIndex);

      return prev.map((item, index) =>
        index === dayIndex ? { ...item, tasksdata: updatedTasks } : item,
      );
    });
  };

  const handleToggle = (option) => {
    setSelected(option);
  };
  const handletaskChange = (event) => {
    settaskname(event.target.value);
  };

  const handletaskdescriptionChange = (event) => {
    settaskdescription(event.target.value);
  };

  const handletaskbioChange = (event) => {
    setbio(event.target.value);
  };

  const handlenormalPer = (event) => {
    setnormalPer(event.target.value);
  };
  const handleeveningPer = (event) => {
    seteveningPer(event.target.value);
  };
  const handlenightPer = (event) => {
    setnightPer(event.target.value);
  };
  const createtask = async () => {
    if (taskname == "") {
      toast.warn("Please fill out a project name");
    } else if (taskdescription == "") {
      toast.warn("Please fill out a project description");
    } else if (bio == "") {
      toast.warn("Please fill out a project bio");
    } else if (customeremail == "") {
      toast.warn("Please enter your project email");
    } else if (customerphonenumber == "") {
      toast.warn("Please enter your project contact number");
    } else if (selected === "option1" && multiplicatorPer == 0) {
      toast.warn("Please fill the Multiplicator Percentage");
    } else if (Location == "") {
      toast.warn("Please select a work location!");
    } else if (selected === "option2" && fixedprice == 0) {
      toast.warn("Please enter the Fixed Price");
    } else if (normalstarttime == "" || normalstarttime == null) {
      toast.warn("Please Enter Normal Start Time");
    } else if (normalendtime == "" || normalendtime == null) {
      toast.warn("Please Enter Normal End Time");
    } else if (normalPer == "") {
      toast.warn("Please Enter Normal Percentage");
    } else if (eveningstarttime == "" || eveningstarttime == null) {
      toast.warn("Please Enter Evening Start Time");
    } else if (eveningendtime == "" || eveningendtime == null) {
      toast.warn("Please Enter Evening End Time");
    } else if (eveningPer == "") {
      toast.warn("Please Enter Evening Percentage");
    } else if (nightstarttime == "" || nightstarttime == null) {
      toast.warn("Please Enter Night Start Time");
    } else if (nightendtime == "" || nightendtime == null) {
      toast.warn("Please Enter Night End Time");
    } else if (nightPer == "") {
      toast.warn("Please Enter Night Percentage");
    } else if (doThreeTimesNotCollide() == false) {
      toast.warn("Time Slots can not overlap");
    } else {
      setloader(true);
      const res = await fetch(
        "https://us-central1-raftekpro-82bb0.cloudfunctions.net/api/createaccount",
        {
          // const res = await fetch('http://localhost:3002/createaccount', {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: customeremail,
            password: "abcd1234",
          }),
        },
      );
      if (res.status == 200) {
        const dataresponse = await res.json();
        if (picture == "") {
          let data = {
            id: dataresponse.data.uid,
            logo: "https://firebasestorage.googleapis.com/v0/b/raftekpro-82bb0.appspot.com/o/profilepicture%2F1719855616981-user.png?alt=media&token=d4fb1df5-e98e-47ea-b695-7467d20e0cfb",
            creationdate: Date.now(),
            title: taskname,
            createdby: user.id,
            description: taskdescription,
            bio: bio,
            email: customeremail,
            location: Location,
            geofenceradius: geofenceRadius,
            geofence: geofenceCenter,
            phonenumber: customerphonenumber,
            usertype: "Project",
            multiplicatorPercentage: multiplicatorPer,
            multiplicatorPercentageStatus:
              selected === "option1" ? true : false,
            fixedprice: fixedprice,
            expressdeliveryfixedhours: expressdeliveryfixedmaxhours,
            expressdeliveryfixed: expressdeliveryfixed,
            expressdeliveryhourly: expressdeliveryhourly,
            fixedpriceStatus: selected === "option2" ? true : false,
            normalstarttime: normalstarttime,
            normalendtime: normalendtime,
            normalPercentage: normalPer,
            eveningstarttime: eveningstarttime,
            eveningendtime: eveningendtime,
            eveningPercentage: eveningPer,
            nightstarttime: nightstarttime,
            nightendtime: nightendtime,
            nightPercentage: nightPer,
            cleaningtasks: cleanertasks,
          };

          await saveuserdata(data, dataresponse.data.uid)
            .then((response) => {
              if (response == "success") {
                toast.success("Project created Successfully");
                settaskdescription("");
                settaskname("");
                setbio("");
                setpicture("");
                setpicturedata("");
                setcustomeremail("");
                setcustomerphonenumber("");
                setpassword("");
                setLocation("");
                setconfirmpassword("");
                setnormalPer("");
                seteveningstarttime("13:01");
                seteveningendtime("19:00");
                seteveningPer("");
                setnightstarttime("19:01");
                setnightendtime("23:59");
                setnightPer("");

                dispatch({
                  type: actionType.STORE_SELECTED_TILE,
                  payload: "Dashboard",
                });
              } else {
                toast.error(
                  "Something went wrong while posting your task. Please try again later.",
                );
              }

              setloader(false);
            })
            .catch((err) => {
              alert(err);
              setloader(false);
            });
        } else {
          const imageFile = picturedata.target.files[0];
          const storageRef = ref(
            storage,
            `profilepicture/${Date.now()}-${imageFile.name}`,
          );
          const uploadTask = uploadBytesResumable(storageRef, imageFile);
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              //   const uploadProgress = (snapshot.bytesTransferred/snapshot.totalBytes)*100
            },
            (error) => {
              setloader(false);
              toast.error("upload error " + error.message);
            },
            () => {
              getDownloadURL(uploadTask.snapshot.ref)
                .then(async (downloadURL) => {
                  let data = {
                    id: dataresponse.data.uid,
                    logo: downloadURL,
                    creationdate: Date.now(),
                    title: taskname,
                    createdby: user.id,
                    description: taskdescription,
                    bio: bio,
                    email: customeremail,
                    phonenumber: customerphonenumber,
                    usertype: "Project",
                    location: Location,
                    geofenceradius: geofenceRadius,
                    geofence: geofenceCenter,
                    multiplicatorPercentage: multiplicatorPer,
                    multiplicatorPercentageStatus:
                      selected === "option1" ? true : false,
                    fixedprice: fixedprice,
                    expressdeliveryfixedhours: expressdeliveryfixedmaxhours,
                    expressdeliveryfixed: expressdeliveryfixed,
                    expressdeliveryhourly: expressdeliveryhourly,
                    fixedpriceStatus: selected === "option2" ? true : false,
                    normalstarttime: normalstarttime,
                    normalendtime: normalendtime,
                    normalPercentage: normalPer,
                    eveningstarttime: eveningstarttime,
                    eveningendtime: eveningendtime,
                    eveningPercentage: eveningPer,
                    nightstarttime: nightstarttime,
                    nightendtime: nightendtime,
                    nightPercentage: nightPer,
                    cleaningtasks: cleanertasks,
                  };

                  await saveuserdata(data, dataresponse.data.uid)
                    .then((response) => {
                      if (response == "success") {
                        toast.success("Project created Successfully");
                        settaskdescription("");
                        setbio("");
                        settaskname("");
                        setpicture("");
                        setpicturedata("");
                        setcustomeremail("");
                        setcustomerphonenumber("");
                        setpassword("");
                        setLocation("");
                        setconfirmpassword("");
                        setnormalstarttime("00:00");
                        setnormalendtime("13:00");
                        setnormalPer("");
                        seteveningstarttime("13:01");
                        seteveningendtime("19:00");
                        seteveningPer("");
                        setnightstarttime("19:01");
                        setnightendtime("23:59");
                        setnightPer("");
                        dispatch({
                          type: actionType.STORE_SELECTED_TILE,
                          payload: "Dashboard",
                        });
                      } else {
                        toast.error(
                          "Something went wrong while posting your task. Please try again later.",
                        );
                      }

                      setloader(false);
                    })
                    .catch((err) => {
                      alert(err);
                      setloader(false);
                    });
                })
                .catch((error) => {
                  setloader(false);
                  toast.error(error.message);
                });
            },
          );
        }
      } else {
        let error = await res.json();
        toast.error(error.error);
        setloader(false);
      }
      // createUserWithEmailAndPassword(auth, customeremail, "abcd1234")
      //     .then(async (userCredential) => {
      //         const createduser = userCredential.user;

      // })
      // .catch((error) => {
      //     const errorCode = error.code;
      //     const errorMessage = error.message;
      //     toast.error(errorMessage)
      //     setloader(false)
      //     // ..
      // });
    }
  };

  const handleimageChange = (event) => {
    fileInput.current.click();
  };

  const handleimageselected = (e) => {
    setpicturedata(e);
    setpicture(URL.createObjectURL(e.target.files[0]));
  };

  const handlecustomeremailChange = (event) => {
    setcustomeremail(event.target.value);
  };

  const handlecustomerphonenumberChange = (event) => {
    setcustomerphonenumber(event.target.value);
  };
  const handlemultiplicatorPer = (event) => {
    setmultiplicatorPer(event.target.value);
  };
  const handlefixedprice = (event) => {
    setfixedprice(event.target.value);
  };

  const handleexpresshourlyprice = (event) => {
    setexpressdeliveryhourly(event.target.value);
  };

  const handleexpressfixedprice = (event) => {
    setexpressdeliveryfixed(event.target.value);
  };

  const handleexpressfixedmaxhours = (event) => {
    setexpressdeliveryfixedmaxhours(event.target.value);
  };

  const handlecpasswordChange = (event) => {
    setpassword(event.target.value);
  };

  const handleconfirmpasswordChange = (event) => {
    setconfirmpassword(event.target.value);
  };

  function doThreeTimesNotCollide() {
    // Convert time strings to Date objects
    function toDate(time) {
      const [hour, minute] = time.split(":").map(Number);
      return new Date(2000, 0, 1, hour, minute);
    }

    // Convert all time strings to Date objects
    const startTime1 = toDate(normalstarttime);
    const endTime1 = toDate(normalendtime);
    const startTime2 = toDate(eveningstarttime);
    const endTime2 = toDate(eveningendtime);
    const startTime3 = toDate(nightstarttime);
    const endTime3 = toDate(nightendtime);

    // Check if two intervals do not collide
    function doIntervalsNotCollide(startA, endA, startB, endB) {
      return endA <= startB || endB <= startA;
    }

    // Check non-collision between all pairs
    const notCollide12 = doIntervalsNotCollide(
      startTime1,
      endTime1,
      startTime2,
      endTime2,
    );
    const notCollide13 = doIntervalsNotCollide(
      startTime1,
      endTime1,
      startTime3,
      endTime3,
    );
    const notCollide23 = doIntervalsNotCollide(
      startTime2,
      endTime2,
      startTime3,
      endTime3,
    );

    // If all pairs do not collide, return true; otherwise, return false
    return notCollide12 && notCollide13 && notCollide23;
  }
  const handledesignationChange = (event, index, type, innerindex) => {
    let data = [...cleanertasks];
    data[index].tasksdata[innerindex].tasks = event.target.value;
    setcleanertasks(data);
  };

  const handletaskdesignationChange = (designation, index, innerindex) => {
    let data = [...cleanertasks];
    data[index].tasksdata[innerindex].designation = designation;
    setcleanertasks(data);
  };

  const handleSelect = async (place) => {
    setLocation(place);
    const address = place.label; // Extract the address string

    try {
      const response = await fromAddress(address);
      const { lat, lng } = response.results[0].geometry.location;
      setgeofenceCenter({
        lat: lat,
        lng: lng,
      });

      //   setCoordinates({ lat, lng });
    } catch (error) {
      console.error("Error fetching geocode:", error);
    }
  };

  const handleLatLngToAddress = async (lat, lng) => {
    try {
      const response = await fromLatLng(lat, lng);
      const address = response.results[0].formatted_address;

      const placeId = response.results[0].place_id;
      setLocation({
        label: address,
        value: {
          description: address,
          place_id: placeId,
          reference: placeId,
          structured_formatting: {
            main_text: address,
            secondary_text: "",
          },
          terms: [],
          types: response.results[0].types || [],
        },
      });

      setlocationKey((prev) => prev + 1); // ✅ force remount
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const dayKeyMap = {
    Monday: "CleaningMonday",
    Tuesday: "CleaningTuesday",
    Wednesday: "CleaningWednesday",
    Thursday: "CleaningThursday",
    Friday: "CleaningFriday",
    Saturday: "CleaningSaturday",
    Sunday: "CleaningSunday",
    Monthly: "MonthlyCleaning",
    Quarterly: "QuarterlyCleaning",
    Yearly: "YearlyCleaning",
  };

  const parseTasks = (taskString = "") =>
    taskString
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean)
      .map((task, index) => ({
        id: index,
        tasks: task,
        completed: false,
        designation: "",
      }));

  // Each task column has a matching designation column, e.g. CleaningMonday -> CleaningMondayDesignation
  const getColumnArray = (rows, columnName) => {
    return rows
      .filter(
        (row) => row[columnName] && row[columnName].toString().trim() !== "",
      )
      .map((row, index) => ({
        id: index,
        tasks: row[columnName],
        completed: false,
        designation: row[`${columnName}Designation`]
          ? row[`${columnName}Designation`].toString().trim()
          : "",
      }));
  };

  //  taskData
  // .filter((row) => row.CleaningMonday) // ignore empty rows
  // .map((row, index) => ({
  //   id: index,
  //   tasks: row.CleaningMonday,
  //   completed: false,
  // }));

  const populateCleanerTasks = (projectdata) => {
    return cleanertasks.map((dayObj) => {
      const excelKey = dayKeyMap[dayObj.day];
      // const tasksArray = parseTasks(projectdata[excelKey]);
      const tasksArray = getColumnArray(projectdata, excelKey);

      return {
        ...dayObj,
        numberoftasks: tasksArray.length || 1,
        tasksdata: tasksArray.length
          ? tasksArray
          : [
              {
                id: 0,
                tasks: "",
                completed: false,
                designation: "",
              },
            ],
      };
    });
  };

  // const resolveAddressFrontend = async (address) => {
  //   const url = `https://maps.googleapis.com/maps/api/place/textsearch/json?query=${encodeURIComponent(
  //     address
  //   )}&key=${apikey}`;

  //   const res = await fetch(url);
  //   const data = await res.json();

  //   if (!data.results || !data.results.length) {
  //     return null;
  //   }

  //   const place = data.results[0];

  //   return {
  //     label: place.formatted_address,
  //     value: {
  //       description: place.formatted_address,
  //       place_id: place.place_id,
  //       reference: place.place_id,
  //       types: place.types || [],
  //     },
  //   };
  // };

  const resolveAddressFrontend = (address) => {
    return new Promise((resolve, reject) => {
      const service = new window.google.maps.places.AutocompleteService();

      service.getPlacePredictions({ input: address }, (predictions, status) => {
        if (
          status !== window.google.maps.places.PlacesServiceStatus.OK ||
          !predictions.length
        ) {
          reject("No place found");
          return;
        }

        const place = predictions[0]; // Take first prediction
        const locationResult = {
          label: place.description,
          value: {
            description: place.description,
            matched_substrings: place.matched_substrings,
            place_id: place.place_id,
            reference: place.place_id,
            structured_formatting: place.structured_formatting,
            terms: place.terms,
            types: place.types || [],
          },
        };

        resolve(locationResult);
      });
    });
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });

      // Read first sheet
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // Convert to JSON
      let jsonData = XLSX.utils.sheet_to_json(sheet);

      let projectdata = jsonData[0];
      let cleaningdata = jsonData;

      settaskname(projectdata.ProjectName || "");
      setbio(projectdata.ProjectBio || "");
      settaskdescription(projectdata.ProjectDescription || "");
      setcustomeremail(projectdata.ProjectEmail || "");
      setcustomerphonenumber(projectdata.ProjectContactNumber || "");
      setgeofenceRadius(projectdata.GeofenceRadius || "");

      setmultiplicatorPer(projectdata.MultiplicatorPrice || "");
      setfixedprice(projectdata.FixedPrice || "");
      setSelected(projectdata.MultiplicatorPrice ? "option1" : "option2");
      setnormalstarttime(projectdata.NormalStartTime || "00:00");
      setnormalendtime(projectdata.NormalEndTime || "13:00");
      setnormalPer(projectdata.NormalTimePercentage || "");
      seteveningstarttime(projectdata.EveningStartTime || "00:00");
      seteveningendtime(projectdata.EveningEndTime || "13:00");
      seteveningPer(projectdata.EveningTimePercentage || "");
      setnightstarttime(projectdata.NightStartTime || "00:00");
      setnightendtime(projectdata.NightEndTime || "13:00");
      setnightPer(projectdata.NightTimePercentage || "");
      const updatedTasks = populateCleanerTasks(cleaningdata);
      setcleanertasks(updatedTasks);
      if (projectdata.Location) {
        setlocationscan(true);
        let formattedlocation = await resolveAddressFrontend(
          projectdata.Location,
        );

        setLocation(formattedlocation);
        setlocationscan(false);
      }
      // for (const key in jsonData) {
      //   if (jsonData[key].Client) {
      //     jsonData[key].Client = "[" + jsonData[key].Client + "]";
      //     jsonData[key].Client = parseClientString(jsonData[key].Client);
      //   }
      // }
      // console.log("THis is all the data " + JSON.stringify(jsonData));

      // jsonData.forEach(async (item) => {
      //   // const selectedagent = employees.find(
      //   //   (data) => data.firstname === item.AgentName
      //   // );
      //   // const selectedagent = findAgent(item.AgentName);
      //   // const selectedteamlead = teamleads.find(
      //   //   (data) => data.firstname.trim() === item.TeamLead.trim()
      //   // );

      //   let datset = {
      //     status: "Approved",
      //     propertyphoto: "",
      //     dealtype: item.ClientType || "",
      //     customers: item.Client,
      //     dealStage: item.DealStage,
      //     financingType: item.FinancingType || "",
      //     earnestMoney: item.EarnestMoney || "",
      //     mlsNumber: item.MLSNumber || "",
      //     offerPrice: item.SalesPrice,
      //     propertyType: item.PropertyType || "",
      //     agentCommission: item.AgentCommission
      //       ? normalizeCommission(item.AgentCommission).toString()
      //       : "",
      //     brokeradminfee: item.BrokerAdminFee || 0,
      //     captype: item.Type?.toLowerCase() || "pre",
      //     captypedescription:
      //       item.Type == "Post"
      //         ? "Post-Cap (100% Commission)"
      //         : "Pre-Cap (90/10 Split)",
      //     closingdate: item.ClosingDate ? toISODate(item.ClosingDate) : "",
      //     inspection: item.Inspection || "",
      //     inspectionDeadline: item.InspectionDeadline || "",
      //     financingDeadline: item.FinancingDeadline || "",
      //     leadsource: item.leadsource || "",
      //     leadCommission: "0",
      //     propertyaddress: item.Propertyaddress,
      //     thirdpartyagentCommission: item.ReferalAgentCommission || "0",
      //     thirdpartyagentName: item.ReferalAgentName || "",
      //     totalcommissionrate: item.TotalCommissionRate || 3.33,
      //     splittype: item.SplitType || "NoSplit",
      //     splitdescription:
      //       item.SplitType == "Referral"
      //         ? "Referral to Outside Agent"
      //         : item.SplitType == "TeamSplit"
      //         ? "Team member Split"
      //         : "No Split",
      //     agentName: item.AgentName || "",
      //     teamleadName: item.TeamLead || "",
      //     agentData: selectedagent ? selectedagent.id : "",
      //     assignedteamlead: selectedteamlead ? selectedteamlead.id : "",
      //     buyersidecommissionrate: "",
      //     sellersidecommissionrate: "",
      //     teamleadcommissionrate: "",
      //     agentCommissionamount: 0,
      //     bankcommission: 0,
      //     leadsourceCommissionamount: 0,
      //     takehomecommissionamount: 0,
      //     teamleadCommissionamount: 0,
      //     thirdpartyagentcommissionamount: 0,
      //     totalCommissionamount: 0,
      //     createdby: user.id,
      //   };

      // });
    };
    reader.readAsBinaryString(file);
  };
  return (
    <div className="pb-[45px]">
      <div className="w-[100%]  px-3 lg:px-7 rounded-xl  py-[20px]  mx-auto overflow-scroll  bg-cardOverlay  drop-shadow-lg bg-themelightblack  mt-[70px] md:mt-[0px] mb-[40px]">
        <div className="flex w-full justify-end pb-[30px]">
          <label
            htmlFor="excelUpload"
            className="inline-flex items-center justify-center cursor-pointer
             px-4 py-2 rounded-md bg-themeblue text-white text-sm
             PoppinsRegular uppercase hover:bg-blue-700
             transition duration-200"
          >
            Upload Excel
          </label>

          <input
            id="excelUpload"
            type="file"
            accept=".xls,.xlsx"
            onChange={handleFileUpload}
            className="hidden"
          />
        </div>

        <div className="w-full flex justify-center">
          <div className="flex justify-center my-[10px] border border-white rounded-full items-center relative mt-5 lg:mt-0">
            {picture ? (
              <img
                loading="lazy"
                src={picture}
                className="w-[110px] h-[110px] object-cover rounded-full  bg-cardOverlay  drop-shadow-lg"
              />
            ) : (
              <FaUser className="text-lighttextGray/80 p-4 border border-bordercolor rounded-full w-[110px] h-[110px]  bg-themelightblack  drop-shadow-lg" />
            )}
            <input
              style={{ display: "none" }}
              type="file"
              accept="image/*"
              ref={fileInput}
              onChange={handleimageselected}
            />
            <div
              onClick={handleimageChange}
              className="absolute bg-themeblue w-[30px] h-[30px] flex justify-center items-center rounded-full right-[-10px] top-[70px] cursor-pointer"
            >
              <MdEdit className="text-textcolor w-[20px] h-[20px]" />
            </div>
          </div>
        </div>

        <div className="w-full">
          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
            Project Name
          </p>
          <input
            type="text"
            value={taskname}
            placeholder="Project Name"
            onChange={handletaskChange}
            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
          />
        </div>
        <div className="w-full mt-5">
          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
            Project Bio
          </p>
          <textarea
            type="text"
            placeholder="Project Bio"
            value={bio}
            onChange={handletaskbioChange}
            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex h-[200px] bg-themelightblack"
          />
        </div>

        <div className="w-full mt-5">
          <p className="PoppinsRegular text-textcolor text-sm  pb-1">
            Project Description
          </p>
          <textarea
            type="text"
            placeholder="Project Description"
            value={taskdescription}
            onChange={handletaskdescriptionChange}
            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex h-[200px] bg-themelightblack"
          />
        </div>

        <div className="w-full mt-[20px]">
          <p className="PoppinsRegular text-textcolor  text-sm pb-1">
            Project Email
          </p>
          <input
            type="text"
            value={customeremail}
            placeholder="Project Email"
            onChange={handlecustomeremailChange}
            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
          />
        </div>
        <div className="w-full mt-[20px]">
          <p className="PoppinsRegular text-textcolor  text-sm pb-1">
            Project Contact Number
          </p>
          <input
            type="text"
            value={customerphonenumber}
            placeholder="Project Contact Number"
            onChange={handlecustomerphonenumberChange}
            className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack"
          />
        </div>

        <LoadScript googleMapsApiKey={apikey} libraries={LIBRARIES}>
          <div className="flex w-full mt-[20px] mb-[10px] justify-between">
            <div className="w-[70%] PoppinsRegular ">
              <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                Location
              </p>
              {!locationscan && (
                <GooglePlacesAutocomplete
                  key={locationKey}
                  apiKey={apikey}
                  selectProps={{
                    Location,
                    onChange: (item) => {
                      handleSelect(item);
                    },
                    placeholder: "Select your address",
                    defaultValue: Location,
                    //                   getOptionLabel: (option) => option.label,  // ✅ tells it how to display
                    // getOptionValue: (option) => option.value?.description, // ✅ unique key
                  }}
                  name="address"
                  value={Location}
                />
              )}
            </div>

            <div className="w-[25%] PoppinsRegular ">
              <p className="PoppinsRegular text-textcolor text-sm  pb-1">
                Geofence (Radius)
              </p>
              <input
                type="number"
                value={geofenceRadius}
                placeholder="Geofence Radius"
                onChange={(event) => {
                  setgeofenceRadius(parseInt(event.target.value));
                }}
                className="input px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-blue-00 items-center flex bg-themelightblack"
              />
            </div>
          </div>

          <div className=" rounded-2xl  overflow-hidden relative flex w-full justify-center items-center border border-bordercolor ">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={geofenceCenter}
              zoom={15}
              options={{
                styles: darkTheme, // apply dark theme
                disableDefaultUI: false, // hide default controls if you want
              }}
            >
              {/* Geofence Circle */}
              <Circle
                center={geofenceCenter}
                radius={geofenceRadius}
                options={{
                  fillColor: "red",
                  fillOpacity: 0.3,
                  strokeWeight: 1,
                  draggable: true,
                }}
              />

              {/* Geofence Center Marker */}
              <Marker
                draggable
                onDragEnd={(e) => {
                  handleLatLngToAddress(e.latLng.lat(), e.latLng.lng());
                  setgeofenceCenter({
                    lat: e.latLng.lat(),
                    lng: e.latLng.lng(),
                  });
                }}
                position={geofenceCenter}
                label="Geofence Center"
              />

              {/* User Location Marker */}
              {/* {userLocation && <Marker position={userLocation} label="You" />} */}
            </GoogleMap>
          </div>
        </LoadScript>

        <div className="w-full mt-[20px] border border-bordercolor  py-[20px] rounded-xl bg-themelightblack px-[20px]">
          <p className="PoppinsRegular text-white  text-lg pb-4">
            {"Express Delivery"}
          </p>
          <div className="flex flex-row justify-between ">
            <div className="flex flex-col w-[49%]">
              <div className="flex flex-col w-[100%]">
                <p className="PoppinsRegular text-white  text-sm pb-1">
                  {"Express Delivery Fixed"}
                </p>

                <div className="input  w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row  bg-white">
                  <div className="pl-5">
                    <FaDollarSign color="black" />
                  </div>
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={5}
                    value={expressdeliveryfixed}
                    placeholder={"Express Delivery Fixed"}
                    onChange={handleexpressfixedprice}
                    className=" p-[0px] text-black text-sm  PoppinsRegular  w-[95%] lg:w-[97%]  px-[17px] lg:px-4 border-none items-center flex bg-white "
                  />
                </div>
              </div>
              <div className="flex flex-col w-[100%] mt-[10px]">
                <p className="PoppinsRegular text-white  text-sm pb-1">
                  {"Fixed Price Maximum Hours"}
                </p>
                <div className="input  w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row  bg-white">
                  <input
                    type="text"
                    inputMode="numeric"
                    maxLength={5}
                    value={expressdeliveryfixedmaxhours}
                    placeholder={"Maximum Hours"}
                    onChange={handleexpressfixedmaxhours}
                    className=" p-[0px] text-black text-sm  PoppinsRegular  w-[95%] lg:w-[97%]  px-[17px] lg:px-4 border-none items-center flex bg-white "
                  />

                  <div className="pr-5">
                    <p className="PoppinsRegular text-black  text-sm pb-1">
                      hours
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col w-[49%]">
              <p className="PoppinsRegular text-white  text-sm pb-1">
                {"Express Delivery Hourly"}
              </p>
              <div className="input  w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row bg-white ">
                <div className="pl-5">
                  <FaDollarSign color="black" />
                </div>
                <input
                  type="text"
                  inputMode="numeric"
                  maxLength={5}
                  value={expressdeliveryhourly}
                  placeholder={"Express Delivery Hourly"}
                  onChange={handleexpresshourlyprice}
                  className=" p-[0px] text-black text-sm  PoppinsRegular  w-[95%] lg:w-[97%]  px-[17px] lg:px-4 border-none items-center flex bg-white "
                />
                <div className="pr-5">
                  <p className="PoppinsRegular text-black  text-sm pb-1">/hr</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="w-full  flex flex-col lg:flex-row justify-center lg:justify-between mt-[20px]">
            <button
              className={`className= w-full lg:w-[48%] rounded-xl border h-[45px] border-bordercolor text-white ${
                selected === "option1" ? "bg-themeblue " : " bg-themeColor "
              }`}
              onClick={() => {
                setmultiplicatorPer(0);
                handleToggle("option1");
              }}
            >
              Multiplicator Price
            </button>
            <button
              className={`className= mt-4 lg:mt-0 w-full lg:w-[48%] rounded-xl border h-[45px] border-bordercolor text-white ${
                selected === "option2" ? "bg-themeblue " : " bg-themeColor "
              }`}
              onClick={() => {
                setfixedprice(0);
                handleToggle("option2");
              }}
            >
              Fixed Price
            </button>
          </div>
          <div className="w-full mt-[20px]">
            <p className="PoppinsRegular text-textcolor  text-sm pb-1">
              {selected === "option1" ? "Multiplicator" : "Price"}
            </p>
            <div className="w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row">
              {selected === "option2" && (
                <div className="pl-5">
                  <FaDollarSign className="text-textcolor" />
                </div>
              )}
              <input
                type="text"
                inputMode="numeric"
                maxLength={selected === "option1" && 4}
                value={selected === "option1" ? multiplicatorPer : fixedprice}
                placeholder={selected === "option1" ? "Multiplicator" : "Price"}
                onChange={
                  selected === "option1"
                    ? handlemultiplicatorPer
                    : handlefixedprice
                }
                className="input p-[0px] text-textcolor text-sm  PoppinsRegular  w-[95%] lg:w-[97%]  px-[17px] lg:px-4 border-none items-center flex bg-themelightblack"
              />
              {selected === "option1" ? null : (
                <p className="text-textcolor  text-lg pr-2 ">/hr</p>
              )}
            </div>
          </div>
          {/* <div className="input-container">
                    {selected === 'option1' && (
                        <input type="text" placeholder="Text input for Heading 1" />
                    )}
                    {selected === 'option2' && (
                        <input type="text" placeholder="Text input for Heading 2" />
                    )}
                </div> */}
        </div>
        <div className="flex flex-col lg:flex-row justify-center lg:justify-between mt-[20px]">
          <div className="w-full lg:w-[32%]">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Normal Start Time
            </p>
            <TimePicker
              format="HH:mm"
              className=" rounded-xl border-bordercolor w-full h-[45px] text-textcolor "
              onChange={setnormalstarttime}
              value={normalstarttime}
            />
          </div>
          <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
            <p className="PoppinsRegular  text-sm pb-1 text-textcolor">
              Normal End Time
            </p>
            <TimePicker
              format="HH:mm"
              className=" rounded-xl  border-bordercolor w-full   h-[45px] text-textcolor "
              onChange={setnormalendtime}
              value={normalendtime}
            />
          </div>

          <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Percentage
            </p>
            <div className="input w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row">
              <input
                type="text"
                value={normalPer}
                placeholder="Normal Percentage"
                onChange={handlenormalPer}
                inputMode="numeric"
                maxLength={3}
                className=" text-textcolor text-sm  PoppinsRegular border-none p-[0px] w-[95%] lg:w-[90%] px-[17px] bg-themelightblack "
              />
              <div>
                <FaPercent className="text-white" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-center lg:justify-between mt-[20px]">
          <div className="w-full lg:w-[32%]">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Evening Start Time
            </p>
            <TimePicker
              format="HH:mm"
              className=" rounded-xl  border-bordercolor w-full   h-[45px] text-textcolor "
              onChange={
                seteveningstarttime
                //     (time) => {
                //     doTwoTimesNotCollide(normalstarttime, normalendtime, time, eveningendtime, 'start')
                // }
              }
              value={eveningstarttime}
            />
          </div>
          <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Evening End Time
            </p>
            <TimePicker
              format="HH:mm"
              className=" rounded-xl  border-bordercolor w-full   h-[45px] text-textcolor "
              onChange={
                seteveningendtime
                //     (time) => {
                //     doTwoTimesNotCollide(normalstarttime, normalendtime, eveningstarttime, time, 'end')
                // }
              }
              value={eveningendtime}
            />
          </div>

          <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Percentage
            </p>
            <div className="input w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row">
              <input
                type="text"
                value={eveningPer}
                placeholder="Evening Percentage"
                onChange={handleeveningPer}
                inputMode="numeric"
                maxLength={3}
                className="  text-textcolor text-sm  PoppinsRegular border-none p-[0px] w-[95%] lg:w-[90%] px-[17px] bg-themelightblack"
              />
              <div>
                <FaPercent className="text-white" />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-center lg:justify-between mt-[20px]">
          <div className="w-full lg:w-[32%]">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Night Start Time
            </p>
            <TimePicker
              format="HH:mm"
              className=" rounded-xl  border-bordercolor w-full   h-[45px] text-textcolor "
              onChange={setnightstarttime}
              value={nightstarttime}
            />
          </div>
          <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Night End Time
            </p>
            <TimePicker
              format="HH:mm"
              className=" rounded-xl  border-bordercolor w-full   h-[45px] text-textcolor "
              onChange={setnightendtime}
              value={nightendtime}
            />
          </div>
          <div className="w-full lg:w-[32%] mt-4 lg:mt-0">
            <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
              Percentage
            </p>
            <div className="input w-full py-[10px] rounded-xl border border-bordercolor items-center flex flex-row">
              <input
                type="text"
                value={nightPer}
                placeholder="Night Percentage"
                onChange={handlenightPer}
                inputMode="numeric"
                maxLength={3}
                className="  text-textcolor text-sm  PoppinsRegular border-none p-[0px] w-[95%] lg:w-[90%] px-[17px] bg-themelightblack"
              />
              <div>
                <FaPercent className="text-white" />
              </div>
            </div>
          </div>
        </div>
        {/* <div className='w-full mt-[20px]' >
            <p className='PoppinsRegular text-textcolor  text-sm pb-1'>Password</p>
            <input type="password"
            value={password} placeholder='Password'
            onChange={handlecpasswordChange}
            className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex"/>
        </div>
        <div className='w-full mt-[20px]' >
            <p className='PoppinsRegular text-textcolor  text-sm pb-1'>Confirm Password</p>
            <input type="password"
            value={confirmpassword} placeholder='Confirm Password'
            onChange={handleconfirmpasswordChange}
            className="px-4 text-textcolor text-sm  PoppinsRegular w-full py-2 rounded-xl border border-bordercolor items-center flex"/>
        </div> */}
        <div className="flex flex-row items-center pt-10">
          <p className="PoppinsRegular   text-sm pb-1 text-textcolor">
            Cleaning Tasks
          </p>
          <p className="PoppinsRegular   text-sm pb-1  text-lighttextGray ml-[5px]">
            {"(Optional)"}
          </p>
        </div>

        <div className="mt-[20px] ">
          {cleanertasks.map((item, index) => (
            <div>
              <div className="flex flex-row pt-[5px] pb-[5px] items-center">
                <p className="PoppinsRegular   text-sm   text-textcolor">
                  {item.day}
                </p>
                <input
                  type="text"
                  value={item.numberoftasks}
                  placeholder="Task count.."
                  onChange={(event) => {
                    let newdata = [...cleanertasks];
                    newdata[index].numberoftasks = event.target.value;

                    if (
                      newdata[index].numberoftasks !=
                        newdata[index].tasksdata.length &&
                      newdata[index].numberoftasks != ""
                    ) {
                      if (
                        newdata[index].numberoftasks >
                        newdata[index].tasksdata.length
                      ) {
                        const nextId =
                          newdata[index].tasksdata.length > 0
                            ? Math.max(
                                ...newdata[index].tasksdata.map((t) =>
                                  Number(t.id),
                                ),
                              ) + 1
                            : 0;
                        const itemsToAdd = Array.from(
                          {
                            length:
                              newdata[index].numberoftasks -
                              newdata[index].tasksdata.length,
                          },
                          (_, index) => ({
                            id: nextId + index,
                            tasks: "",
                            completed: false,
                            designation: "",
                          }),
                        );
                        newdata[index].tasksdata.push(...itemsToAdd);
                      } else {
                        newdata[index].tasksdata.splice(
                          newdata[index].numberoftasks -
                            newdata[index].tasksdata.length,
                        );
                      }
                    }
                    setcleanertasks(newdata);
                  }}
                  className="input px-2 text-textcolor text-sm  PoppinsRegular w-[60px] py-2 rounded-xl border border-bordercolor items-center flex bg-themelightblack text-center ml-[5px]"
                />
                <div
                  onClick={() => {
                    let data = [...cleanertasks];
                    data[index].numberoftasks =
                      parseInt(data[index].numberoftasks) + parseInt(1);
                    data[index].numberoftasks =
                      data[index].numberoftasks.toString();
                    let object = {
                      id: data[index].numberoftasks,
                      tasks: "",
                      completed: false,
                      designation: "",
                    };
                    data[index].tasksdata.push(object);
                    setcleanertasks(data);
                  }}
                  className=" flex justify-center  flex-col items-center hover:cursor-pointer ml-[5px]"
                >
                  <CiCirclePlus className="text-themegreen w-[20px] h-[20px]" />
                </div>
              </div>
              <DndContext
                collisionDetection={closestCenter}
                onDragEnd={(event) => {
                  handleTaskDragEnd(index, event);
                }}
              >
                <SortableContext
                  items={item?.tasksdata.map((f) => f.id)}
                  strategy={verticalListSortingStrategy}
                >
                  {item?.tasksdata.map((inneritem, innerindex) => (
                    <SortableItem
                      key={inneritem.id}
                      id={inneritem.id}
                      inneritem={inneritem}
                      innerindex={innerindex}
                      index={index}
                      setcleanertasks={setcleanertasks}
                      handledesignationChange={handledesignationChange}
                      handletaskdesignationChange={handletaskdesignationChange}
                      designations={[]}
                      cleanertasks={cleanertasks}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            </div>
          ))}
        </div>
        {loader ? (
          <div className=" py-4  mt-6 w-full flex justify-center  ">
            <RotatingLines
              visible={true}
              height="25"
              width="25"
              color="grey"
              strokeColor="#00C763"
              strokeWidth="5"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        ) : (
          <button
            onClick={() => {
              createtask();
            }}
            type="submit"
            className="text-center py-4 rounded-2xl mt-6 bg-themeblue hover:bg-themeblue/80 w-full  mx-auto text-white text-sm  PoppinsRegular uppercase"
          >
            Create Project
          </button>
        )}
      </div>
    </div>
  );
}

export default CreateProject;
